function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

// Scripts
import 'snippets/breadcrumbs/breadcrumbs';
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-hero/page-hero';
import './_addresses.scss';
var selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};
var attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};
class CustomerAddresses {
  constructor() {
    _defineProperty(this, "_handleAddEditButtonClick", _ref => {
      var currentTarget = _ref.currentTarget;
      this._toggleExpanded(currentTarget);
    });
    _defineProperty(this, "_handleCancelButtonClick", _ref2 => {
      var currentTarget = _ref2.currentTarget;
      this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector("[".concat(attributes.expanded, "]")));
    });
    _defineProperty(this, "_handleDeleteButtonClick", _ref3 => {
      var currentTarget = _ref3.currentTarget;
      // eslint-disable-next-line no-alert
      if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
        Shopify.postLink(currentTarget.dataset.target, {
          parameters: {
            _method: 'delete'
          }
        });
      }
    });
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }
  _getElements() {
    var container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }
  _setupCountries() {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      this.elements.countrySelects.forEach(select => {
        var formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector("AddressCountry_".concat(formId), "AddressProvince_".concat(formId), {
          hideElement: "AddressProvinceContainer_".concat(formId)
        });
      });
    }
  }
  _setupEventListeners() {
    this.elements.toggleButtons.forEach(element => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach(element => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach(element => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }
  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }
}
window.CustomerAddresses = CustomerAddresses;
document.addEventListener('DOMContentLoaded', () => {
  new CustomerAddresses();
});